import React from 'react';
import { Info } from 'lucide-react';

export const KurzErklaertBox = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-3xl p-10 lg:p-12 shadow-lg">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0">
              <div className="w-14 h-14 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                <Info className="w-7 h-7 text-brand-green" />
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-brand-green-dark mb-4">Kurz erklärt</h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                Nach einem Unfall ist es wichtig, strukturiert vorzugehen. Die richtigen Schritte helfen dabei, Ansprüche zu sichern und spätere Probleme zu vermeiden. Diese Übersicht zeigt, was in der Praxis wirklich zählt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};